/**
 * Created by Itay on 6/26/2016.
 */

(function btHistoricGraphModalClosure() {
  'use strict';

  angular
    .module('ecapp')
    /**
     * This directive display historical data section for release: header, chart and table.
     * Really and header to btHistoricGraph directive.
     *
     * @ngdoc directive
     * @name btHistoricGraphModal
     * @memberOf ecapp
     */
    .directive('btHistoricGraphModal', [
      '$templateCache',
      function ($templateCache) {
        return {
          restrict: 'E',
          template: $templateCache.get('directives/common/historic-graph/historic-graph-modal.html'),
        };
      },
    ]);
})();
